module.exports = __webpack_public_path__ + "img/logo2.1d8f0fbc.png";